import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { UUIDGenerator } from './../../../../utils/uuid-generator';
import { MensagensDeErro } from './mensagens-input-erro';

@Component({
  selector: 'shared-input-lovers',
  templateUrl: './input-lovers.component.html',
  styleUrls: ['./input-lovers.component.scss'],
})
export class InputLoversComponent implements OnInit {
  @Input() controlName: string = '';
  @Input() type: string = '';
  @Input() mask: string = '';
  @Input() pattern: string = '';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() labelError: string = '';
  @Input() disabled: boolean = false;
  @Input() habilitaIconeCheck: boolean = false;
  @Input() habilitaIconeErro: boolean = false;
  @Input() habilitaIconeAlerta: boolean = false;
  @Input() set iconeDireito(value:string) {this.iconeDireitoSrc = value;};
  // @Input() iconeDireito:string = '';
  @Input() iconeEsquerdo: string = '';
  @Input() labelCampoValidado: string = '';
  @Input() mensagemGenerica: string = '';
  @Input() exibirSenha: boolean = false;
  @Input() maxlength: number;
  @Input() tab: number;
  @Input() id:string;
  @Input() loading:boolean = false;
  
  @Output() valueChanged = new EventEmitter<string>();
  @Output() onBlur = new EventEmitter<null>();

  public iconeDireitoSrc:string = '';
  public isInputFocused: boolean = false;
  public mostrarSenha: boolean = false;

  public formGroup!: FormGroup;
  public corPrincipal:boolean = false;

  constructor(
    private formGroupDirective: FormGroupDirective,
    private UUID: UUIDGenerator
  ) { }

  ngOnInit(): void {
    this.formGroup = this.formGroupDirective.form;
    this.identificarCorFundo();
  }

  onInputFocus(): void {
    this.isInputFocused = true;
  }

  onInputBlur(): void {
    this.isInputFocused = false;
    this.onBlur.emit();
  }

  identificarCorFundo()
  {
    const element = document.getElementById(this.id);
 
    if(element)
    {
      let elementoAtual = element.parentElement;
      let corDeFundo = 'rgba(0, 0, 0, 0)'; // Cor padrão

      while (elementoAtual) {
        const estilo = window.getComputedStyle(elementoAtual);
        const corAtual = estilo.backgroundColor;

        if (corAtual && corAtual !== 'rgba(0, 0, 0, 0)') {
          
          if(corAtual == "rgb(115, 32, 41)")
            this.corPrincipal = true;
          
            corDeFundo = corAtual;
            break;
        }

        elementoAtual = elementoAtual.parentElement;
    }

    }
  }

  public campoInvalidoEVazio(): boolean {
    const controle = this.formGroup.get(this.controlName);

    if (controle?.invalid && (controle?.dirty || controle?.touched)) {
      if (controle?.errors?.senhaIncorreta) {
        return true;
      }
      
      if(controle.errors && controle.touched && controle?.errors?.NaoDisponivel) return true;

      if(controle.errors && controle.touched && controle.errors?.invalido) return true;

      if(controle.errors && controle.touched && controle.errors?.email) return true;

      if(controle.errors && controle.touched && controle.errors?.minlength) return true;

      if(controle.errors && controle.touched && controle.errors?.pattern) return true;

      if(controle.errors && controle.touched && controle.errors?.emailNaoDisponivel) return true;

      if(controle.errors && controle.touched && controle.errors?.telefoneNaoDisponivel) return true;

      if(controle.errors && controle.touched && controle.errors?.telefoneInvalido) return true;
      
      if(controle.errors && controle.touched && controle.errors?.cpf) return true;

      if(controle.errors && controle.touched && controle.errors?.responsavelNaoCadastrado) return true;

      if (!controle?.value) {
        return true;
      }
    }

    return
  }

  public onInputChange(event: Event): void {
    const controle = this.formGroup.get(this.controlName);

    if(!(event.target as HTMLInputElement).value) return;

    const value = (event.target as HTMLInputElement).value;
    this.valueChanged.emit(value);
  }

  public toggleSenha() {
    this.mostrarSenha = !this.mostrarSenha;

    if (this.mostrarSenha == true) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  public getPlaceholder(): string {
    if (
      this.isInputFocused &&
      this.formGroup.get(this.controlName)?.value == ''
    ) {
      return this.placeholder;
    } else {
      return '';
    }
  }

  reset()
  {
    const controle = this.formGroup.get(this.controlName);
    this.habilitaIconeCheck = false;
    this.habilitaIconeErro  = false;
    this. habilitaIconeAlerta  = false;
    controle.markAsUntouched();
  }

  getMessageError() : string {
    const controle = this.formGroup.get(this.controlName);

    if(controle.valid || !controle.touched) return;

    if(this.labelError) return this.labelError;

    const primeiroErro = Object.keys(controle.errors)[0];
    return MensagensDeErro.obterMensagem(primeiroErro);
  }
}
